// What the site's pages show about each game: the registry's games (finished ones first, then those in
// development), a letter tile until each game has a picture, and "2–8 players".
import { GAMES } from '../../games/registry';
import type { GameDef } from '../../games/registry';

export const inDevelopment = (g: GameDef) => g.status !== 'playable';
export const SITE_GAMES: readonly GameDef[] = GAMES.filter(g => g.hasModule && g.status !== 'placeholder')
  .slice().sort((a, b) => Number(inDevelopment(a)) - Number(inDevelopment(b)));
export const READY_GAMES = SITE_GAMES.filter(g => !inDevelopment(g));
export const DEV_GAMES = SITE_GAMES.filter(inDevelopment);

export const gameName = (id: string) => GAMES.find(g => g.id === id)?.name ?? id;
export const gameLetter = (g: GameDef) => g.name[0];
export const playersText = (g: GameDef) => (g.minPlayers === g.maxPlayers ? `${g.minPlayers} players` : `${g.minPlayers}–${g.maxPlayers} players`);

// The room's game list: the games most recently worked on first.
const RECENT = ['capture-the-flag', 'baduk-analysis', 'heist-city', 'stumble-home', 'van-life', 'classic-cards', 'dice-factory', 'lodden-thinks', 'henhur', 'kill-team-draft'];
const recency = (id: string) => { const i = RECENT.indexOf(id); return i < 0 ? RECENT.length : i; };
export const ROOM_GAMES_ORDER: readonly GameDef[] = SITE_GAMES.slice().sort((a, b) => recency(a.id) - recency(b.id));

// A screenshot of the game in progress, shown at the top of the room (games without one show a stand-in).
const ROOM_ART: Record<string, { src: string; alt: string }> = {
  'capture-the-flag': { src: '/assets/rooms/capture-the-flag.jpg', alt: 'A game of Conquer the Flag in progress: blue and red units around the center' },
};
export const roomArt = (id: string) => ROOM_ART[id] ?? null;
